import { render, staticRenderFns } from "./feeReceiptReport.vue?vue&type=template&id=70763424&scoped=true"
import script from "./feeReceiptReport.vue?vue&type=script&lang=js"
export * from "./feeReceiptReport.vue?vue&type=script&lang=js"
import style0 from "./feeReceiptReport.vue?vue&type=style&index=0&id=70763424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70763424",
  null
  
)

export default component.exports